<a class="data-card__footer__see-more" [class.disabled]="isLoading" (click)="clickSeeMore.emit()">
  {{ 'DATA_CARD.SEE_MORE' | translate }}
</a>
